import axios from 'axios';
import { API_PATH_PARTIDOS } from '../constantes/constantes';

export default async function getEventosPartidos(liga = "europa-league") {
  const apiURL = `${API_PATH_PARTIDOS}${encodeURIComponent(liga)}.json`;
  
  try {
    const { data, status } = await axios.get(apiURL, {
      timeout: 25000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json; charset=utf-8',
      },
    });

    return { data, statusCode: status };
  } catch (error) {
    const statusCode = error.response?.status || 500;
    console.error("Error en la petición:", error.message || error);
    return { statusCode, data: [] };
  }
}